import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { LinkField, linkUrl } from '@/lib/link'

import { SharedButtonProps } from './Button'
import { PhnxButton } from './Button'

interface ButtonProps {
  blok: {
    label: string
    link: LinkField
    icon: string
    size: SharedButtonProps['size']
    variant: SharedButtonProps['variant']
    iconPosition: SharedButtonProps['iconPosition']
    disabled: SharedButtonProps['disabled']
    openinnewwindow: boolean
  } & SbBlokData
}

const Button: FC<ButtonProps> = ({ blok }) => {
  const href = linkUrl(blok.link)
  const checkWindow = blok.link.target === '_blank'

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxButton
        type="link"
        label={blok.label}
        icon={blok.icon}
        iconPosition={blok.iconPosition}
        size={blok.size}
        variant={blok.variant}
        openInNewWindow={checkWindow.toString()}
        href={href}
        disabled={blok.disabled}
      />
    </div>
  )
}

export default Button
